import { css } from 'styled-components';
import { MODAL_CONTAINER_Z_INDEX } from './tokens';
//
// Tokens
//
export const CFBaseModalContainerTokens = {};
//
// Helpers
//
export const CFBaseModalContainerHelpers = {
    rootDisplay: ({ active }) => {
        return active
            ? css `
          display: flex;
        `
            : css `
          display: none;
        `;
    },
};
//
// Element Styles
//
export const CFBaseModalContainerStyles = {
    Root: css `
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${MODAL_CONTAINER_Z_INDEX};
  `,
    RootWeb: css `
    position: fixed;
    ${CFBaseModalContainerHelpers.rootDisplay};
  `,
};
